// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E2T_","question":"styles_question__1ZUPN","inputVisibleButton":"styles_inputVisibleButton__M-tqm","note":"styles_note__1oZe7"};